
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NavLinks from "@/components/NavLinks";
import AuthLinks from "@/components/AuthLinks";
import MobileMenu from "@/components/MobileMenu";


const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, isLoading } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-300 ${
      isScrolled ? "bg-white shadow-sm" : "bg-white"
    }`}>
      
      <div className="h-[66px] sm:h-[86px] flex items-center">
        <div className="container-custom flex items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center">
              <img
                src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Peca%20Email/Logo%20Nome.png"
                alt="AmeUp — Sistema de Gestão para Buffet"
                className="h-14 sm:h-16"
              />
            </Link>
            <NavLinks />
          </div>

          <AuthLinks user={user} isLoading={isLoading} />

          <div className="md:hidden">
            <MobileMenu />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
